module.exports = __webpack_public_path__ + "static/media/button-on.509f92e1.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/button-on.gif
// module id = 291
// module chunks = 0